import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "type"];
import React from 'react';
import classnames from 'classnames';
import './index.css';
const Iconfont = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    type
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    iconfont: true,
    [`icon${type}`]: !!type,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("i", _extends({
    className: cls,
    ref: ref
  }, others));
});
export default Iconfont;